const CATEGORY_LABELS = Object.freeze({
  crochet: 'Crochet',
  flowers: 'Flowers',
  'fridge-magnets': 'Magnets',
  decorations: 'Decor',
  gifts: 'Gifts',
});

export const catalogCategoryNavigation = Object.freeze(
  Object.entries(CATEGORY_LABELS).map(([slug, label]) => ({ slug, label }))
);

export const primaryCategoryNavigation = Object.freeze(
  catalogCategoryNavigation.filter(({ slug }) => slug !== 'decorations')
);

export function getCategoryLabel(category = {}) {
  return CATEGORY_LABELS[category.slug] || category.name || 'Products';
}
